import { FeatureFlag } from '../FeatureFlag';

export const enableLab2GroupByStatusToggle = new FeatureFlag({
    key: 'enable-lab-2-group-by-status-toggle',
    defaultValue: false,
});
